import React from "react";
import HighlightsItem from "components/SingleProductPage/HighlightsItem";
import { ListElement } from "utils/types/util.types";
import { useTranslation } from "react-i18next";
import { isArray, isEmptyString } from "utils/types/typeguards";

type Props = {
	productTextId: string,
}

function SingleProductPageHighlights({
	productTextId,
}: Props) {

	const { t } = useTranslation();

	const title = t([ `products.${ productTextId }.highlights.title`, "" ]);
	const highlightsItems = t([ `products.${ productTextId }.highlights.elements`, "" ], { returnObjects: true }) as ListElement[] | string;

	const hasAnyElements = () => !(
		isEmptyString(title) &&
		!isArray(highlightsItems)
	);

	if (!hasAnyElements()) return <></>

	return (
		<div className="container">
			<div className="flex flex-col gap-4 bg-zinc-200 rounded-3xl p-7 sm:p-14 mt-10">
				{
					!isEmptyString(title) &&
                    <h2 className="text-black font-medium">
						{ title }
                    </h2>
				}
				{
					isArray(highlightsItems) &&
                    <div className="flex flex-col gap-4">
						{
							highlightsItems.map(({ title, description }, index) =>
								<HighlightsItem
									key={ index }
									title={ title }
									description={ description }
									number={ index + 1 }
								/>
							)
						}
                    </div>
				}
			</div>
		</div>
	);
}

export default SingleProductPageHighlights;